<template>
    <div class="layout">
        <header>
            <div class="container">
                <div class="top_menu">
                    <h1>
                        <router-link to="/"><img src="@/assets/img/logo.svg" alt="에이드소프트 로고"></router-link>
                    </h1>
                    <div class="right_menu dn">
                        <router-link to="/consult" class="gocontactBtn">문의하기</router-link>
                        <a href="/files/aidsoft.pdf" download="회사소개서.pdf" class="companyDown">
                            회사소개서
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                <mask id="mask0_1237_1021" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="25" height="25">
                                    <rect x="0.96875" y="0.464844" width="24" height="24" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_1237_1021)">
                                    <path
                                        d="M16.6225 11.4648L12.9688 15.1186L9.315 11.4648L10.3688 10.4111L12.2188 12.2303V7.81109H13.7188V12.2303L15.5688 10.4111L16.6225 11.4648ZM11.0842 20.2918H14.8533V19.4071H11.0842V20.2918ZM8.2765 22.9648C7.77133 22.9648 7.34375 22.7898 6.99375 22.4398C6.64375 22.0898 6.46875 21.6623 6.46875 21.1571V3.77259C6.46875 3.26743 6.64375 2.83984 6.99375 2.48984C7.34375 2.13984 7.77133 1.96484 8.2765 1.96484H17.661C18.1662 1.96484 18.5938 2.13984 18.9438 2.48984C19.2938 2.83984 19.4688 3.26743 19.4688 3.77259V21.1571C19.4688 21.6623 19.2938 22.0898 18.9438 22.4398C18.5938 22.7898 18.1662 22.9648 17.661 22.9648H8.2765ZM7.96875 16.7341H17.9688V6.21484H7.96875V16.7341Z"
                                        fill="#A9820D" />
                                </g>
                            </svg>
                        </a>
                    </div>
                    <button type="button" class="mob_bar" @click="mobMenu">
                        <i :class="mobmenu ? 'pi pi-times' : 'pi pi-bars'"></i>
                    </button>
                </div>
                <div class="bottom_menu">
                    <nav class="dn">
                        <ul>
                            <li>
                                <router-link to="/home">홈</router-link>
                            </li>
                            <li>
                                <router-link to="/company">회사소개</router-link>
                            </li>
                            <li>
                                <router-link to="/business">사업분야</router-link>
                            </li>
                            <li>
                                <router-link
                                    to="/webmob"
                                    class="hasSub"
                                    @mouseenter="showSubmenu1 = true"
                                    @mouseleave="showSubmenu1 = false"
                                    :class="{ active: isActive('/webmob') || isActive('/mobileapp') || isActive('/iot') || isActive('/video') || isActive('/poskiosk') || isActive('/customSoftware') }"
                                >
                                    <span>서비스</span> 
                                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18"
                                        fill="none">
                                        <mask id="mask0_1634_3110" style="mask-type:alpha" maskUnits="userSpaceOnUse"
                                            x="0" y="0" width="19" height="18">
                                            <rect x="0.292969" width="18" height="18" fill="#D9D9D9" />
                                        </mask>
                                        <g mask="url(#mask0_1634_3110)">
                                            <path d="M13.793 6.75L9.29297 11.25L4.79297 6.75" stroke="black"
                                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                    </svg>
                                    <ul v-show="showSubmenu1" class="submenu">
                                        <li>
                                            <router-link to="/webmob">웹(모바일 웹)</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/mobileapp">모바일 앱</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/iot">IOT 서비스</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/video">동영상 미디어 서비스</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/poskiosk">POS/Kiosk</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/customSoftware">맞춤형 소프트웨어</router-link>
                                        </li>
                                    </ul>
                                </router-link>
                            </li>
                            <li>
                                <router-link
                                    to="/onmice"
                                    class="hasSub"
                                    @mouseenter="showSubmenu2 = true"
                                    @mouseleave="showSubmenu2 = false"
                                    :class="{ active: isActive('/onmice') || isActive('/classnaom') }"
                                >
                                    <span>솔루션</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18"
                                        fill="none">
                                        <mask id="mask0_1634_3110" style="mask-type:alpha" maskUnits="userSpaceOnUse"
                                            x="0" y="0" width="19" height="18">
                                            <rect x="0.292969" width="18" height="18" fill="#D9D9D9" />
                                        </mask>
                                        <g mask="url(#mask0_1634_3110)">
                                            <path d="M13.793 6.75L9.29297 11.25L4.79297 6.75" stroke="black"
                                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                    </svg>
                                     <ul v-show="showSubmenu2" class="submenu">
                                        <li>
                                            <router-link to="/onmice">온마이스</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/classnaom">클래스나옴</router-link>
                                        </li>
                                    </ul>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/portfolio" :class="{ active: isActive('/portfolio/view') }">포트폴리오</router-link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </header>
        <!-- 모바일 메뉴 -->
        <div class="mob_menu" v-if="mobmenu">
            <nav>
                <ul>
                    <li>
                        <router-link to="/home" @click="mobMenu">Home</router-link>
                    </li>
                    <li>
                        <router-link to="/company" @click="mobMenu">회사소개</router-link>
                    </li>
                    <li>
                        <router-link to="/business" @click="mobMenu">사업분야</router-link>
                    </li>
                    <li>
                        <a href="javascript:void(0);"  class="hasSub" @mouseenter="showSubmenu1 = true" @mouseleave="showSubmenu1 = false">
                            <span>서비스</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18"
                                fill="none">
                                <mask id="mask0_1634_3110" style="mask-type:alpha" maskUnits="userSpaceOnUse"
                                    x="0" y="0" width="19" height="18">
                                    <rect x="0.292969" width="18" height="18" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_1634_3110)">
                                    <path d="M13.793 6.75L9.29297 11.25L4.79297 6.75" stroke="black"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                            </svg>
                            <ul v-show="showSubmenu1" class="submenu">
                                <li>
                                    <router-link to="/webmob" @click="mobMenu">웹(모바일 웹)</router-link>
                                </li>
                                <li>
                                    <router-link to="/mobileapp" @click="mobMenu">모바일 앱</router-link>
                                </li>
                                <li>
                                    <router-link to="/iot" @click="mobMenu">IOT 서비스</router-link>
                                </li>
                                <li>
                                    <router-link to="/video" @click="mobMenu">동영상 미디어 서비스</router-link>
                                </li>
                                <li>
                                    <router-link to="/poskiosk" @click="mobMenu">POS/Kiosk</router-link>
                                </li>
                                <li>
                                    <router-link to="/customSoftware" @click="mobMenu">맞춤형 소프트웨어</router-link>
                                </li>
                            </ul>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0);"  class="hasSub" @mouseenter="showSubmenu2 = true" @mouseleave="showSubmenu2 = false">
                                <span>솔루션</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18"
                                    fill="none">
                                    <mask id="mask0_1634_3110" style="mask-type:alpha" maskUnits="userSpaceOnUse"
                                        x="0" y="0" width="19" height="18">
                                        <rect x="0.292969" width="18" height="18" fill="#D9D9D9" />
                                    </mask>
                                    <g mask="url(#mask0_1634_3110)">
                                        <path d="M13.793 6.75L9.29297 11.25L4.79297 6.75" stroke="black"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                </svg>
                                 <ul v-show="showSubmenu2" class="submenu">
                                    <li>
                                        <router-link to="/onmice" @click="mobMenu">온마이스</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/classnaom" @click="mobMenu">클래스나옴</router-link>
                                    </li>
                                </ul>
                            </a>
                    </li>
                    <li>
                        <router-link to="/portfolio" @click="mobMenu">포트폴리오</router-link>
                    </li>
                    <li>
                        <router-link to="/consult" @click="mobMenu">문의하기</router-link>
                    </li>
                    <li>
                        <a href="/files/aidsoft.pdf" download="회사소개서.pdf" class="companyDown">
                                회사소개서
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                    <mask id="mask0_1237_1021" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                        width="25" height="25">
                                        <rect x="0.96875" y="0.464844" width="24" height="24" fill="#D9D9D9" />
                                    </mask>
                                    <g mask="url(#mask0_1237_1021)">
                                        <path
                                            d="M16.6225 11.4648L12.9688 15.1186L9.315 11.4648L10.3688 10.4111L12.2188 12.2303V7.81109H13.7188V12.2303L15.5688 10.4111L16.6225 11.4648ZM11.0842 20.2918H14.8533V19.4071H11.0842V20.2918ZM8.2765 22.9648C7.77133 22.9648 7.34375 22.7898 6.99375 22.4398C6.64375 22.0898 6.46875 21.6623 6.46875 21.1571V3.77259C6.46875 3.26743 6.64375 2.83984 6.99375 2.48984C7.34375 2.13984 7.77133 1.96484 8.2765 1.96484H17.661C18.1662 1.96484 18.5938 2.13984 18.9438 2.48984C19.2938 2.83984 19.4688 3.26743 19.4688 3.77259V21.1571C19.4688 21.6623 19.2938 22.0898 18.9438 22.4398C18.5938 22.7898 18.1662 22.9648 17.661 22.9648H8.2765ZM7.96875 16.7341H17.9688V6.21484H7.96875V16.7341Z"
                                            fill="#A9820D" />
                                    </g>
                                </svg>
                            </a>
                    </li>
                </ul>
            </nav>
        </div>

        <router-view></router-view>
     
        <footer>
            <div class="f_logo">
                <img src="@/assets/img/flogo.svg" alt="에이드소프트 로고">
            </div>
            <div class="center">
                <h5>고객센터</h5>
                <p>02-723-0337</p>
            </div>
            <address>
                <p>서울시 강동구 양재대로 1377 삼원빌딩 413호 에이드소프트</p>
                <p>사업자 등록번호 215-87-88685</p>
                <p>통신판매업신고 : 제 2020-서울강동-0862호</p>
                <p>이메일 : contct@aidsoft.kr / 팩스번호 : 070 - 4324 - 0077 </p>
            </address>
        </footer>
    </div>
</template>

<script>
import router from '@/router';

export default {
    name: 'Layout',
    data() {
        return {
            mobmenu: false,
            showSubmenu1: false,
            showSubmenu2: false
        }
    },
     computed: {
        currentRoute() {
            return this.$route.path; // 현재 라우트 경로 가져오기
        }
    },
    methods: {
        mobMenu() {
            this.mobmenu = !this.mobmenu;
            // body 스크롤 막기
            if (this.mobmenu) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = 'auto';
            }
        },
        isActive(route) {
            return this.currentRoute.startsWith(route);
        }
    }

}
</script>
